import React from 'react'

export default ({PLACEHOLDER, ...props}) => (
    <svg width="19" height="149" viewBox="0 0 19 149" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.34668 20.6585V18.5299L18.7522 0.5V2.62853L0.34668 20.6585Z" />
      <path d="M0.34668 24.7903V22.6618L18.7522 4.63184V6.76038L0.34668 24.7903Z" />
      <path d="M0.34668 28.9221V26.7936L18.7522 8.76367V10.8922L0.34668 28.9221Z" />
      <path d="M0.34668 33.054V30.9254L18.7522 12.8955V15.024L0.34668 33.054Z" />
      <path d="M0.34668 37.1858V35.0573L18.7522 17.0273V19.1559L0.34668 37.1858Z" />
      <path d="M0.34668 41.3176V39.1891L18.7522 21.1592V23.2877L0.34668 41.3176Z" />
      <path d="M0.34668 45.4495V43.321L18.7522 25.291V27.4196L0.34668 45.4495Z" />
      <path d="M0.34668 49.5818V47.4533L18.7522 29.4233V31.5519L0.34668 49.5818Z" />
      <path d="M0.34668 53.7132V51.5846L18.7522 33.5547V35.6832L0.34668 53.7132Z" />
      <path d="M0.34668 57.845V55.7164L18.7522 37.6865V39.8151L0.34668 57.845Z" />
      <path d="M0.34668 61.9768V59.8483L18.7522 41.8184V43.9469L0.34668 61.9768Z" />
      <path d="M0.34668 66.1087V63.9801L18.7522 45.9502V48.0787L0.34668 66.1087Z" />
      <path d="M0.34668 70.241V68.1125L18.7522 50.0825V52.211L0.34668 70.241Z" />
      <path d="M0.34668 74.3723V72.2438L18.7522 54.2139V56.3424L0.34668 74.3723Z" />
      <path d="M0.34668 78.5042V76.3756L18.7522 58.3457V60.4742L0.34668 78.5042Z" />
      <path d="M0.34668 82.6365V80.508L18.7522 62.478V64.6066L0.34668 82.6365Z" />
      <path d="M0.34668 86.7683V84.6398L18.7522 66.6099V68.7384L0.34668 86.7683Z" />
      <path d="M0.34668 90.9002V88.7716L18.7522 70.7417V72.8702L0.34668 90.9002Z" />
      <path d="M0.34668 95.0315V92.903L18.7522 74.873V77.0016L0.34668 95.0315Z" />
      <path d="M0.34668 99.1638V97.0353L18.7522 79.0054V81.1339L0.34668 99.1638Z" />
      <path d="M0.34668 103.296V101.167L18.7522 83.1372V85.2657L0.34668 103.296Z" />
      <path d="M0.34668 107.428V105.299L18.7522 87.269V89.3976L0.34668 107.428Z" />
      <path d="M0.34668 111.559V109.431L18.7522 91.4009V93.5294L0.34668 111.559Z" />
      <path d="M0.34668 115.691V113.563L18.7522 95.5327V97.6612L0.34668 115.691Z" />
      <path d="M0.34668 119.823V117.694L18.7522 99.6646V101.793L0.34668 119.823Z" />
      <path d="M0.34668 123.955V121.826L18.7522 103.796V105.925L0.34668 123.955Z" />
      <path d="M0.34668 128.087V125.958L18.7522 107.928V110.057L0.34668 128.087Z" />
      <path d="M0.34668 132.219V130.09L18.7522 112.06V114.189L0.34668 132.219Z" />
      <path d="M0.34668 136.35V134.222L18.7522 116.192V118.32L0.34668 136.35Z" />
      <path d="M0.34668 140.482V138.354L18.7522 120.324V122.452L0.34668 140.482Z" />
      <path d="M0.34668 144.614V142.485L18.7522 124.456V126.584L0.34668 144.614Z" />
      <path d="M0.34668 148.746V146.617L18.7522 128.587V130.716L0.34668 148.746Z" />
    </svg>
)
